import logger from "../art-logger-config";

export type LOCAL_STORAGE_KEY =
  | "ASIN_TABLE_PREFERENCES"
  | "VALIDATION_TABLE_PREFERENCES"
  | "BASELINE_TABLE_PREFERENCES"
  | "NOTIFICATION_PREFERENCES"
  | "ONE_CLICK_LAUNCH_TABLE_PREFERENCES";

export function writeToLocalStorage(key: LOCAL_STORAGE_KEY, value: string) {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(key, value);
    }
  } catch (e: any) {
    logger.error(
      `Failed to save local storage key "${key}" with error: ${e.toString()}`
    );
  }
}

export function getFromLocalStorage(key: LOCAL_STORAGE_KEY): string | null {
  try {
    if (typeof window !== "undefined") {
      const valueFromStorage = window.localStorage.getItem(key);
      return valueFromStorage;
    }
  } catch (e: any) {
    logger.error(
      `Failed to load local storage key "${key}" with error: ${e.toString()}`
    );
  }
  return null;
}
